import { z } from 'zod';
import { MonthArray, MonthArrayNoNull } from './common.js';
export const Item = z.object({
    id: z.number().int(),
    name: z.string().min(1).max(160),
    budgets: MonthArrayNoNull,
    actuals: MonthArray,
    sort_order: z.number().int(),
});
export const CreateItemRequest = z.object({
    name: z.string().min(1).max(160),
});
export const UpdateItemRequest = z
    .object({
    name: z.string().min(1).max(160).optional(),
    budgets: MonthArrayNoNull.optional(),
    actuals: MonthArray.optional(),
    sort_order: z.number().int().optional(),
})
    .refine((v) => Object.keys(v).length > 0, { message: 'no fields provided' });
